import React from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import { Checkbox, InputLabel, MenuItem, OutlinedInput, FormControl, Select, SelectChangeEvent } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import { makeStyles } from "@mui/styles";

type RefinementListProps = {
  refine: Function;
  onlyRefined: boolean;
  items: Array<object>;
  heading?: string;
  currentRefinement: string[];
  size?: "small" | "medium" | undefined;
  className?: string;
};

// const useStyles = makeStyles((theme) => ({
//   select: {
//     "& .MuiSvgIcon-root": {
//       color: theme.palette.secondary,
//     },
//   },
// }));

const RefinementList: React.FunctionComponent<any> = (props): JSX.Element | null => {
  // const classes = useStyles();

  const { refine, items, heading, size, className }: RefinementListProps = props;
  const [selectValue, setSelectValue] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof selectValue>) => {
    const {
      target: { value },
    } = event;

    if (Array.isArray(value)) {
      refine(value[0]);
    }
  };

  return (
    <FormControl fullWidth size={size} className={className}>
        <InputLabel id={`${heading}-label-select`} color="secondary">
          {heading}
        </InputLabel>
        <Select
        color="info"
          disabled={!items.length}
          labelId={`${heading}-label-select`}
          id={`${heading}-select`}
          value={selectValue}
          // label={inputLabel}
          onChange={handleChange}
          sx={{ backgroundColor: "#fff" }}
          multiple
          // MenuProps={{ keepMounted: true, disablePortal: true }}
          input={
            <OutlinedInput
              size={size}
              label={heading}
              //onClick={() => setOpen(true)}
            />
          }
          // className={classes.select}
          // open={open}
          // onClose={() => setOpen(false)}
          // onOpen={() => setOpen(true)}
          // renderValue={(selected) => {
          //   return Array.isArray(selected) ? selected.join(", ") : selected;
          // }}
          IconComponent={KeyboardArrowDownIcon}
        >
          {items.map((item: any, itemIndex: number) => (
            <MenuItem className={className} key={`${item.label}-${itemIndex}`} value={item.value}>
              <Checkbox
                  checked={item.isRefined}
                  // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  //   event.stopPropagation();
                  //   setOpen(true);
                  // }}
                  //aria-label={`${item.label}, ${item.count} träffar`}
                />
              {`${item.label} - (${item.count})`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
  );
};

export default connectRefinementList(RefinementList);
